import { render, staticRenderFns } from "./IconShoppingCoupon.vue?vue&type=template&id=11fb137e&scoped=true&"
import script from "./IconShoppingCoupon.vue?vue&type=script&lang=js&"
export * from "./IconShoppingCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fb137e",
  null
  
)

export default component.exports